import React from "react";
import { useNavigate } from "react-router-dom";

const Card = ({ id,title, image, category, author, date, readTime, content }) => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col overflow-hidden rounded-lg shadow-lg hover:scale-105 transform ease-in-out duration-[1s]"
      onClick={() => {
        navigate(`/blog/${id}`);
      }}
    >
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={image} alt="" />
      </div>
      <div className="flex flex-1 flex-col justify-between bg-white p-6 hover:bg-teal-50">
        <div className="flex-1">
          <p className="text-sm font-medium text-emerald-600">
            <a href="#" className="hover:underline">
              {category}
            </a>
          </p>
          <a href="#" className="mt-2 block">
            <p className="text-xl font-semibold text-teal-950">{title}</p>
            <p className="mt-3  text-gray-500">{content}</p>
          </a>
        </div>
        <div className="mt-6 flex items-center">
          <div className="ml-0">
            <p className="text-sm font-medium text-emerald-600">
              <a href="#" className="hover:underline">
                {author}
              </a>
            </p>
            <div className="flex space-x-1 text-sm text-gray-500">
              <time datetime={date}>{date}</time>
              <span aria-hidden="true">·</span>
              <span>{readTime} min read</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
